import React from 'react';
import { useAppSelector } from '../app/hooks';
import getThemeLookup from '../selectors/getThemeLookup';
import { TEXT_PROPERTIES } from '../utils/theme';
import Text from './Text';
import combineStyles from '../utils/combineStyles';
import { OrderingHooks } from 'polygon-ordering';
import { useTranslation } from 'react-i18next';

const { useFormattedCurrency } = OrderingHooks;

const DeliverySurchargeLine = ({
  label,
  original = 0,
  amount,
  deemphasised = false,
  emphasised = false,
  skipFormatting,
  hideSymbol = false,
}: {
  label: string;
  original?: number;
  amount: number | string;
  deemphasised?: boolean;
  emphasised?: boolean;
  skipFormatting?: boolean;
  hideSymbol?: boolean;
}) => {
  const p = useAppSelector(getThemeLookup);
  const { t } = useTranslation();
  const originalValue = useFormattedCurrency({ cents: Number(original), hideSymbol });
  const value = useFormattedCurrency({ cents: Number(amount), hideSymbol });
  const newValue = skipFormatting ? amount : value;

  let additionalStyle;

  if (deemphasised) {
    additionalStyle = p('orderTotalDeemphasised', TEXT_PROPERTIES);
  } else if (emphasised) {
    additionalStyle = null;
  } else {
    additionalStyle = p('orderTotalDeemphasised', ['fontSize', 'fontWeight']);
  }

  return (
    <div style={styles.line}>
      <Text themeKey="orderTotal" style={combineStyles(styles.orderTotalLabel, additionalStyle)}>
        {label}
      </Text>

      <div>
        {original !== 0 && (
          <Text
            themeKey="orderTotal"
            style={{
              ...additionalStyle,
              marginRight: 4,
              textDecoration: 'line-through',
            }}
          >
            {skipFormatting ? original : originalValue}
          </Text>
        )}

        <Text
          themeKey="orderTotal"
          style={{
            ...additionalStyle,
            fontWeight: 'bolder',
          }}
        >
          {Number(amount) === 0 ? t('free') : newValue}
        </Text>
      </div>
    </div>
  );
};

export default DeliverySurchargeLine;

const styles: Styles = {
  line: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 6,
  },
};
